module.exports = __webpack_public_path__ + "static/fonts/Fact-NarrowExtraBold.dcccff4.ttf";